import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import './../css/Login.css';

const AddColorForm = () => {
  const [colorName, setColorName] = useState('');
  const [colorValue, setColorValue] = useState('#000000'); // Default color
  const [colors, setColors] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchColors = async () => {
      const colorsCollection = collection(db, "Colors");
      const colorSnapshot = await getDocs(colorsCollection);
      const colorList = colorSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setColors(colorList);
    };

    fetchColors();
  }, []);

  const validateColorName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName === '') {
      return 'Color name cannot be empty.';
    }
    if (/[^a-zA-Z0-9\s]/.test(trimmedName)) {
      return 'Color name contains invalid characters.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validateColorName(colorName);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const newColor = await addDoc(collection(db, "Colors"), {
        name: colorName,
        color: colorValue
      });
      alert(`Color "${colorName}" added successfully!`);
      setColors([...colors, { id: newColor.id, name: colorName, color: colorValue }]);
      setColorName('');
      setColorValue('#000000'); // Reset color picker
      setError('');
    } catch (e) {
      console.error("Error adding color: ", e);
      alert('Error adding color.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "Colors", id));
      setColors(colors.filter(color => color.id !== id));
      alert('Color deleted successfully!');
    } catch (e) {
      console.error("Error deleting color: ", e);
      alert('Error deleting color.');
    }
  };

  return (
    <>
      <PageTitle title="Add Color - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">Color</h1>
        <hr />
        <p className='unbounded fw-bold black-bordered-bottom'>Add Color</p>
        <form onSubmit={handleSubmit}>
          <div>
            <div className="flex-column">
              <label className='nunito-2'>Color Name*</label>
            </div>
            <div className="inputForm">
              <input
                type="text"
                value={colorName}
                onChange={(e) => setColorName(e.target.value)}
                required
                className="input"
                style={{ fontWeight: "bold" }}
                placeholder='Enter the name of the color you want to add'
              />
            </div>
            {error && <p className='error-message'>{error}</p>}
          </div>
          <br />
          <div>
            <div className="flex-column">
              <label className='nunito-2'>Color Picker</label>
            </div>
            <div className="inputForm">
              <input
                type="color"
                value={colorValue}
                onChange={(e) => setColorValue(e.target.value)}
                className="input"
              />
            </div>
          </div>
          <br />
          <button type="submit" className='black-button'>Add Color</button>
        </form>

        <hr />
        <div className='container'>
          <p className='unbounded fw-bold black-bordered-bottom'>List Of Colors</p>
          <ul>
            {colors.map((color, index) => (
              <li key={color.id} className='d-flex justify-content-between my-2'>
                <span>
                        {index + 1}. {color.name} 
                        <span
                            style={{
                            backgroundColor: color.color,
                            color: color.color === '#ffffff' ? '#000000' : '#ffffff', // Change text color based on background
                            padding: '2px 5px',
                            borderRadius: '3px',
                            marginLeft: '5px',
                            border: '2px solid black'
                            }}
                        >
                            {color.color}
                        </span>
                </span>
                <button className='red-button' onClick={() => handleDelete(color.id)}>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path><path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path></svg>    
                  &nbsp; Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Layout>
    </>
  );
};

export default AddColorForm;
